/**
 * ═══════════════════════════════════════════════════════════════════════
 * ЗЕРКАЛО СПИСКА ВЫГРУЗОК. ИСТОЧНИК — `src/rk/vygruzki.ts`.
 *
 * Меню рисует браузер, а файлы собирает служба. Разойдись эти два
 * списка — и человек нажмёт на строку, которой на сервере нет; ответом
 * будет 404 без единого слова о причине.
 *
 * Сторож `src/rk/vygruzki.spec.ts` сверяет оба списка ЗНАК В ЗНАК.
 * Правка здесь без правки там (и наоборот) не проходит проверки.
 *
 * ПРАВИТЬ ОБА ФАЙЛА СРАЗУ. Это не неудобство, а единственное место,
 * где расхождение видно раньше, чем его увидит человек.
 * ═══════════════════════════════════════════════════════════════════════
 */

export interface ВидВыгрузки {
  /** Ключ в адресе: `/campaigns.xlsx`, `/products.xlsx`, … */
  ключ: string;
  /** Название строкой меню — слово в слово из эталона. */
  название: string;
  /** Пояснение под названием — тоже из эталона. */
  пояснение: string;
  /** Готова ли выгрузка. Неготовая рисуется меткой «в разработке». */
  готово: boolean;
}

export const ВЫГРУЗКИ: readonly ВидВыгрузки[] = Object.freeze([
  {
    ключ: 'campaigns',
    название: 'Таблицу кампаний',
    пояснение: 'как на экране: графы, отбор и период',
    готово: true,
  },
  {
    ключ: 'products',
    название: 'Товары по кампаниям',
    пояснение: 'строка — товар: расход, заказы, стоимость заказа',
    готово: true,
  },
  {
    ключ: 'platforms',
    название: 'Поиск и рекомендации',
    пояснение: 'то же по товарам, но раздельно по площадкам',
    готово: false,
  },
  {
    ключ: 'clusters',
    название: 'Запросы и ставки',
    пояснение: 'кластеры кампаний со ставками и заказами',
    готово: true,
  },
  {
    ключ: 'other-orders',
    название: 'Другие заказы',
    пояснение: 'товары вне кампаний, заказанные через рекламу',
    готово: false,
  },
]);

/** Приписка под списком — слово в слово из эталона. */
export const ПРИПИСКА_ВЫГРУЗКИ =
  'Период и отбор берутся с экрана. Файл собирается на сервере: ' +
  'до 50 000 строк, ссылка приходит на почту, если строк больше.';

export const ФОРМАТЫ = ['xlsx', 'csv'] as const;
export type Формат = (typeof ФОРМАТЫ)[number];

/**
 * Адрес выгрузки.
 *
 * ПЕРИОД И ОТБОР ПРИХОДЯТ СТРОКОЙ С ЭКРАНА, а не собираются здесь
 * заново: собери их второй раз — и однажды в файле окажется не тот
 * период, что в таблице. Спорить с таким файлом невозможно, он
 * выглядит как правда.
 */
export function адресВыгрузки(
  base: string,
  ключ: string,
  формат: Формат,
  q: string,
): string {
  const хвост = формат === 'csv' ? 'format=csv' : '';
  const строка = [q, хвост].filter((с) => с !== '').join('&');
  return `/api/rk${base}/${ключ}.${формат}${строка === '' ? '' : `?${строка}`}`;
}
